<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">ŠIFARNIK PROCESA</h2>

  <div class="content-block">
    <div class="customTable">
      <dx-data-grid
        class="my-40"
        [showColumnLines]="true"
        [dataSource]="procesi"
        noDataText="{{ noDataMessage }}"
        [wordWrapEnabled]="true"
        keyExpr="id"
        (onRowInserted)="onAddProcess($event)"
        (onRowUpdated)="onProcessUpdate($event)"
        (onRowRemoved)="onProcessRemove($event)"
        [disabled]="pravaZaTrenutniPogled != 2"
      >
        <dxo-editing
          mode="popup"
          [allowUpdating]="true"
          [allowAdding]="true"
          [allowDeleting]="true"
        >
          <dxo-popup
            title="Proces"
            [showTitle]="true"
            [width]="500"
            [height]="'auto'"
          >
          </dxo-popup>
          <dxo-form>
            <dxi-item
              dataField="aktivan"
              editorType="dxSelectBox"
              [editorOptions]="{ items: ['Neaktivan', 'Aktivan'] }"
            ></dxi-item>
            <dxi-item dataField="naziv"></dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column cellTemplate="aktivan" [width]="60">
          <div *dxTemplate="let data of 'aktivan'">
            <span
              *ngIf="data.data.aktivan === 'Aktivan'"
              class="activeProcess"
            ></span>
            <span
              *ngIf="data.data.aktivan === 'Neaktivan'"
              class="inactiveProcess"
            ></span>
          </div>
        </dxi-column>
        <dxi-column dataField="aktivan" caption="" [width]="0"></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Proces"
          [width]="300"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
